module.exports = __webpack_public_path__ + "02dc2bc95b661357e28cd8d22acc243a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2_2023_chart.png
// module id = 1677
// module chunks = 0